export const
    always_getting_smarter = require('./always_getting_smarter.svg'),
    arrow_howitworks = require('./arrow_howitworks.svg'),
    fast_smart_fun = require('./fast_smart_fun.svg'),
    get_restocked_magically = require('./get_restocked_magically.svg')